import useCurrentGameId from '@/shared/hooks/useCurrentGameId';
import { useQuery } from '@tanstack/react-query';
import { get } from '@truefit/http-utils';

export const queryKey = ['GameSwitch'] as const;

const useGameSwitchQuery = () => {

  const gameId = useCurrentGameId();

  return useQuery({
    queryKey: [...queryKey, gameId],
    queryFn: async () => {

      return await get<any>(`/v1.0/games/${gameId}/switch`);
    },
    retry: (failureCount, error: any) => {
      // Don't retry on session corruption errors
      if (error?.name === 'SessionCorruptionError' || error?.code === 'SESSION_CORRUPTED') {
        return false;
      }
      return failureCount < 2; // Retry twice for other errors
    },
    enabled: false,
    refetchOnWindowFocus: false,
  });
};

export default useGameSwitchQuery;